export const ADMIN_AUDIT_STATS_REQUEST_DATA =
  'auditReport/ADMIN_AUDIT_STATS_REQUEST_DATA';
export const ADMIN_AUDIT_STATS_RECEIVE_DATA =
  'auditReport/ADMIN_AUDIT_STATS_RECEIVE_DATA';
